import { useState } from "react";
import { Link, NavLink } from "react-router-dom";

const logoUrl = "https://customer-assets.emergentagent.com/job_lactee-upgrade/artifacts/0li3umt4_ecole-la-voie-lactee2.png";

function DesktopItem({ label, to, items, open, setOpen }) {
  const hasMenu = items && items.length > 0;
  const isOpen = open === label;

  if (!hasMenu) {
    return (
      <NavLink
        to={to}
        className={({ isActive }) =>
          `px-3 py-2 rounded-full text-sm font-semibold transition-colors duration-200 ${
            isActive ? "bg-orange-200 text-amber-900" : "text-slate-700 hover:bg-orange-100"
          }`
        }
      >
        {label}
      </NavLink>
    );
  }

  return (
    <div
      className="relative"
      onMouseEnter={() => setOpen(label)}
      onMouseLeave={() => setOpen(null)}
    >
      <span className="px-3 py-2 rounded-full text-sm font-semibold text-slate-700 hover:bg-orange-100 cursor-default inline-flex items-center gap-1">
        {label}
        <svg width="16" height="16" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M6 8l4 4 4-4" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/></svg>
      </span>
      {isOpen && (
        <div
          className="absolute left-0 top-full pt-2"
          onMouseEnter={() => setOpen(label)}
          onMouseLeave={() => setOpen(null)}
        >
          <div className="w-64 rounded-xl border border-orange-100 bg-white shadow-lg">
            <div className="py-2">
              {items.map((it) => (
                <NavLink
                  key={it.to}
                  to={it.to}
                  className={({ isActive }) => `block px-4 py-2 text-sm ${isActive ? 'bg-orange-50 text-amber-900' : 'text-slate-700 hover:bg-orange-50'}`}
                >
                  {it.label}
                </NavLink>
              ))}
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default function Navbar() {
  const [open, setOpen] = useState(null);
  const [mobileOpen, setMobileOpen] = useState(false);

  const menus = [
    {
      label: "Présentation",
      items: [
        { label: "Principes pédagogiques", to: "/principes-pedagogiques" },
        { label: "Charte", to: "/charte" },
        { label: "Historique", to: "/historique" },
      ],
    },
    {
      label: "Structure de l'école",
      items: [
        { label: "L'agencement intérieur", to: "/agencement-interieur" },
        { label: "Quelle pédagogie", to: "/quelle-pedagogie" },
        { label: "Quels outils", to: "/quels-outils" },
      ],
    },
    {
      label: "Activités",
      items: [
        { label: "Activités des classes", to: "/activites-des-classes" },
        { label: "Activités de l'école", to: "/activites-ecole" },
      ],
    },
    { label: "Informations", to: "/informations" },
    { label: "Articles", to: "/articles" },
    { label: "Liens", to: "/liens" },
    { label: "Contact", to: "/contact" },
  ];

  return (
    <header className="sticky top-0 z-40 backdrop-blur bg-white/70 border-b border-orange-100">
      <div className="max-w-6xl mx-auto px-4">
        <div className="flex items-center justify-between h-16">
          <Link to="/" className="flex items-center gap-3">
            <img src={logoUrl} alt="La Voie Lactée" className="h-10 w-auto rounded-full bg-black/80 p-1" />
            <span className="font-black tracking-wide text-slate-800">La Voie Lactée</span>
          </Link>
          <nav className="hidden md:flex items-center gap-2">
            {menus.map((m) => (
              <DesktopItem key={m.label} label={m.label} to={m.to} items={m.items} open={open} setOpen={setOpen} />
            ))}
          </nav>
          <button
            className="md:hidden inline-flex items-center justify-center rounded-full p-2 text-slate-700 hover:bg-orange-100"
            onClick={() => setMobileOpen((v) => !v)}
            aria-label="Ouvrir le menu"
          >
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M4 7h16M4 12h16M4 17h16" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
            </svg>
          </button>
        </div>
      </div>
      {mobileOpen && (
        <div className="md:hidden border-t border-orange-100 bg-white">
          <div className="max-w-6xl mx-auto px-4 py-3">
            <ul className="space-y-2">
              {menus.map((m) => (
                <li key={m.label}>
                  {m.items ? (
                    <details className="group">
                      <summary className="cursor-pointer text-slate-800 font-semibold py-2 flex items-center justify-between">
                        {m.label}
                        <span className="ml-2 text-slate-500 group-open:rotate-180 transition">▾</span>
                      </summary>
                      <ul className="pl-3 border-l border-orange-100 ml-2 space-y-1">
                        {m.items.map((it) => (
                          <li key={it.to}>
                            <NavLink to={it.to} onClick={() => setMobileOpen(false)} className="block py-1 text-slate-700">{it.label}</NavLink>
                          </li>
                        ))}
                      </ul>
                    </details>
                  ) : (
                    <NavLink to={m.to} onClick={() => setMobileOpen(false)} className="block py-2 text-slate-800 font-semibold">{m.label}</NavLink>
                  )}
                </li>
              ))}
            </ul>
          </div>
        </div>
      )}
    </header>
  );
}